import React from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./Home.scss"
import homejson from "../assets/mock/db/banners/home.json"
import trending from "../assets/mock/db/games/trending.json"
import special from "../assets/mock/db/games/special.json"
import premium from "../assets/mock/db/games/premium.json"
import BannerSlider from "../commonComponents/BannerSlider"
import CommonSlider from "../commonComponents/CommonSlider"

function Home() {
    console.log('inside home container')
    const settings = {
        dots: true,
        infinite: true,
        speed: 500
    };
    return (
        <div className="container m-w">
            <BannerSlider
                settings={{
                ...settings,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true
            }}
                data={homejson}/>
            <CommonSlider
                settings={{
                    ...settings,
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%',
                    swipeToSlide: true
                }}
                title="ألعاب مميزة"
                data={premium}
             />
            <CommonSlider
                settings={{
                    ...settings,
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%',
                    swipeToSlide: true
                }}
                title="العاب شائعة"
                data={trending}
             />
             <CommonSlider
                settings={{
                    ...settings,
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%',
                    swipeToSlide: true
                }}
                title="العاب خاصة"
                data={special}
             />
             
        </div>
    )
}

export default Home